exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".xue-scroll-wrapper {\n  width: 100%;\n  height: 100%;\n  overflow-y: hidden;\n  position: relative; }\n  .xue-scroll-wrapper .xue-scroll-container {\n    transition: transform 50ms ease; }\n  .xue-scroll-wrapper .xue-scroll-y-track {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.04);\n    display: none; }\n    .xue-scroll-wrapper .xue-scroll-y-track.y-visible {\n      display: block; }\n    .xue-scroll-wrapper .xue-scroll-y-track .xue-scroll-bar {\n      width: 14px;\n      height: 80px;\n      max-height: 100%;\n      transition: transform 50ms ease;\n      background-color: #c1c1c1; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/packages/scroll/style/index.scss
// module id = 198
// module chunks = 0